module.exports = __webpack_public_path__ + "img/32.7.Chla.315d0adc.png";